const { serialize } = require("../../utils");
export default {
  namespaced: true,
  state: {
    path: "aljabr/activity-days",
  },
  actions: {
    // Filial va akademik yil kesimidagi faoliyat kunlari shablonlari
    get({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/?${serialize(options)}`, method: "GET", data: {} }, { root: true });
      }
    },
    // Shablonga tanlash uchun xodimlar ro'yxati
    staffers({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/staffers?${serialize(options)}`, method: "GET", data: {} }, { root: true });
      }
    },
    // Yangi faoliyat kuni shabloni (yaratish va darhol shakllantirish)
    add({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/add`, method: "POST", data }, { root: true });
      }
    },
    // Shablonni tahrirlash va qayta shakllantirish
    save({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/save`, method: "POST", data }, { root: true });
      }
    },
    // O'zgartirishsiz qayta shakllantirish
    generate({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/generate`, method: "POST", data }, { root: true });
      }
    },
    // Shablonni o'chirish
    remove({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/remove`, method: "POST", data }, { root: true });
      }
    },
    // Yangi xodim qo'shilganda uning faoliyat kunlarini shakllantirish
    applyToStaffer({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/apply-to-staffer`, method: "POST", data }, { root: true });
      }
    },
  },
};
